import type { GetSpaceCodeServiceConfig, GetSpaceSettingsServiceConfig, SpacesListServiceConfig } from '@/services/httpServices/SpacesServices/types';

import { createQueryKey } from './queryKeyUtils';

export function spacesListKeys(config?: SpacesListServiceConfig) {
  return createQueryKey(['spacesList'], config);
}

/**
 * Creates a unique query key for infinite spaces list queries
 * Includes 'infinite' prefix to differentiate from regular list queries
 */
export function infiniteSpacesListKeys(config?: SpacesListServiceConfig) {
  return ['infinite', ...spacesListKeys(config)];
}

export function spaceSettingsKeys(config?: GetSpaceSettingsServiceConfig) {
  return createQueryKey(['spaceSettings'], config);
}

export function spaceCodeKeys(config?: GetSpaceCodeServiceConfig) {
  return createQueryKey(['spaceCode'], config);
}
